import { createSlice } from '@reduxjs/toolkit';
import {
  acceptLoanP2P,
  createLoanP2P,
  getAllLoansP2P,
  getSessionLoansP2P,
  getUserLoanP2P,
} from './thunks';
import { StateLoansP2P } from './state';

export const initialStateLoansP2P: StateLoansP2P = {
  loans_p2p: {
    total: 0,
    loans_p2p: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  userLoanP2P: {},
  sessionLoansP2P: {},
  loading: false,
};

const loansSlice = createSlice({
  name: 'loans_p2p',
  initialState: initialStateLoansP2P, // Define initial state

  reducers: {
    setLoans: (state: any, action: any) => {
      state.loans_p2p = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createLoanP2P.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createLoanP2P.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createLoanP2P.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllLoansP2P.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllLoansP2P.rejected, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllLoansP2P.fulfilled, (state, action) => {
      state.loans_p2p = action.payload;
      state.loading = false;
    });
    builder.addCase(getUserLoanP2P.fulfilled, (state, action) => {
      state.loans_p2p = action.payload;
    });
    builder.addCase(getSessionLoansP2P.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSessionLoansP2P.fulfilled, (state, action) => {
      state.sessionLoansP2P = action.payload;
    });

    builder.addCase(acceptLoanP2P.fulfilled, (state, _action) => {
      state.loading = false;
    });
    builder.addCase(acceptLoanP2P.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(acceptLoanP2P.pending, (state) => {
      state.loading = true;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setLoans } = loansSlice.actions;

// Export reducer generated by "createSlice()":
export default loansSlice.reducer;
